/*
 * @Author: zhangyuansheng zhangyuansheng@elinkmart.com
 * @Date: 2025-02-20 15:13:00
 * @LastEditors: zhangyuansheng zhangyuansheng@elinkmart.com
 * @LastEditTime: 2025-03-12 18:03:34
 * @FilePath: \productweb-web\产品网站3.0\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: zhangyuansheng zhangyuansheng@elinkmart.com
 * @Date: 2025-02-20 15:13:00
 * @LastEditors: zhangyuansheng zhangyuansheng@elinkmart.com
 * @LastEditTime: 2025-03-12 10:18:40
 * @FilePath: \产品网站3.0\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router/index"
import { createPinia } from "pinia"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"
// 引入svg icon插件
import initSvgIcon from "./icons/index"
import "virtual:svg-icons-register"
import installElementPlus from "./plugins/element"
// import setupPermission from "@/router/permission"
import setupDirective from "./directive"
import "normalize.css/normalize.css"
// 视频控件
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
// 全局css
import "@/styles/index.scss"
//  import "./styles/index.scss"
//引入并设置ren文件大幅度发
import {useREM} from "./utils/flexible"
// 设置 rem
useREM()
//涌入图片懒加载
import VueLazyload from 'vue-lazyload'



// import Vconsole from 'vconsole'
// // 本地调试时,显示Vconsole
// new Vconsole()
// console.log("%c Line:25 🍩 import.meta", "color:#7f2b82", import.meta);

// import VueMeta from 'vue-meta';
// 引入SEO优化-元信息管理
import { createHead } from '@vueuse/head'
const head = createHead()

const app = createApp(App)

app.use(VueLazyload)
// pinia
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

app.use(router)
// 路由权限控制
// setupPermission()

// 指令
setupDirective(app)

// 使用svg icon组件
app.use(initSvgIcon)
// 使用视频控件
app.use(vue3videoPlay)

// element plus
app.use(installElementPlus)
// app.use(VueMeta);
app.use(head)
app.mount("#app")

